import { ID, LinkedItemSection } from '@griply/types';

// Section membership lives on the parent entity (goal or life area) as
// `section.tasks: ID[]`, not on the task — so adding a task to a section is an
// update to that entity. Returns the new sections array, or undefined when the
// section no longer exists on the entity (e.g. the task's parent was changed
// away from the section's owner mid-create).
export type SectionedTaskHost = {
  sections: LinkedItemSection[] | null;
};

export const addTaskToSection = (
  entity: SectionedTaskHost,
  sectionId: ID,
  taskId: ID,
): LinkedItemSection[] | undefined => {
  if (!entity.sections?.some((section) => section.id === sectionId)) {
    return undefined;
  }

  return entity.sections.map((section) =>
    section.id === sectionId
      ? { ...section, tasks: [...(section.tasks ?? []), taskId] }
      : section,
  );
};
